var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TableInquiry"},[_c('div',[_c('RecordStaff',{ref:"inquirychild",attrs:{"id":_vm.iiid,"partition":_vm.partition}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }